export function factureRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_FACTURE_START":           
        case "FETCH_FACTURES_START":                                 
        case "UPDATE_FACTURE_START":                                 
        case "DELETE_FACTURE_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_FACTURE_FULFILLED":           
        case "FETCH_FACTURES_FULFILLED":                                 
        case "UPDATE_FACTURE_FULFILLED":                                 
        case "DELETE_FACTURE_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_FACTURE_ERROR":
        case "FETCH_FACTURES_ERROR":
        case "UPDATE_FACTURE_ERROR":
        case "DELETE_FACTURE_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}